<template>
  <div class="text-textColor relative">
    <div
      class="h-16 w-full bg-white shadow flex justify-between items-center sticky top-0 z-50 pr-10"
    >
      <div class="w-sidebarWidth bg-white h-full">
        <div class="flex justify-center items-center h-full border-r-1.5">
          <img src="@/assets/logo.svg" class="p-11 object-contain" />
        </div>
      </div>
      <div class="h-10 w-10 rounded-full">
        <VMenu :placements="bottom" :skidding="-60">
          <img
            class="h-full w-full rounded-full"
            src="https://cdn2.iconfinder.com/data/icons/flatfaces-everyday-people-square/128/african_flatcut_boy_man_black_face_avatar-512.png"
          />

          <template #popper>
            <div class="flex flex-col bg-gray-100">
              <p
                @click="goToBackToDash()"
                class="cursor-pointer hover:bg-primary hover:text-white p-2"
              >
                Back to dashboard
              </p>
              <p
                @click="logOut()"
                class="cursor-pointer hover:bg-primary hover:text-white p-2"
              >
                Log Out
              </p>
            </div>
          </template>
        </VMenu>
      </div>
    </div>
    <transition name="fade">
      <div v-if="loading" class="absolute inset-0 bg-white bg-opacity-80">
        <loader class="absolute center-h-v" />
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="success"
        class="bg-black fixed bg-opacity-80 inset-0 z-50 h-screen w-full"
      >
        <div class="fixed center-h-v bg-white shadow-2xl sm:w-1/4 w-3/4 p-5">
          <img
            class="h-14 mx-auto object-contain"
            src="@/assets/icons/check.png"
          />
          <p class="text-center text-sm font-semibold py-5">
            Your password has been changed successfully. Please login again.
          </p>
          <button
            @click="logOut()"
            class="bg-primaryDark w-full text-white font-bold py-2 px-4 rounded"
          >
            Login
          </button>
        </div>
      </div>
      >
    </transition>
    <div class="flex justify-center mt-10">
      <div class="sm:w-1/2 w-full">
        <img
          class="h-24 mx-auto object-contain"
          src="@/assets/icons/lock.png"
        />
        <p class="text-center py-3 text-2xl font-semibold">
          Change your password
        </p>
        <p class="text-center pb-3">
          In order to protect your account, make sure the password:
        </p>
        <div class="flex justify-center">
          <ul class="list-disc text-sm font-bold">
            <li>Has an upper and lower case letter.</li>
            <li>Contains a special character.</li>
            <li>Is at least 8 characters long.</li>
            <li>Has a number. (0-9)</li>
          </ul>
        </div>
        <form @submit.prevent="changePassword">
          <div class="flex flex-col gap-3 justify-center w-1/2 mx-auto mt-3">
            <transition name="fade">
              <div
                v-if="error"
                class="text-xs border-1.5 border-red-400 mt-6 flex items-center p-2 gap-4 w-full"
              >
                <img class="h-5" src="@/assets/icons/cross.png" />
                <p class="font-bold">{{ error }}</p>
              </div>
            </transition>
            <div>
              <label class="text-xs">Old Password</label>
              <input
                v-model="data.CurrentPassword"
                required
                type="password"
                class="font-semibold block rounded-full border-1.5 p-1 w-full"
              />
            </div>
            <div>
              <label class="text-xs">New Password</label>
              <input
                v-model="data.NewPassword"
                required
                type="password"
                class="font-semibold block rounded-full border-1.5 p-1 w-full"
              />
            </div>
            <div>
              <label class="text-xs">Confirm Password</label>
              <input
                v-model="data.ConfirmPassword"
                required
                type="password"
                class="font-semibold block rounded-full border-1.5 p-1 w-full"
              />
            </div>
          </div>
          <div class="w-full flex justify-center mt-8">
            <button
              class="text-sm bg-primaryDark hover:bg-buttonColor text-white sm:w-1/3 w-1/2 font-bold py-2 px-4 rounded"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../components/loader/loader.vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "ChangePassword",
  components: {
    Loader,
  },
  data() {
    return {
      loading: false,
      success: false,
      error: null,
      bottom: "",
      data: {
        CurrentPassword: "",
        NewPassword: "",
        ConfirmPassword: "",
      },
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
  },

  methods: {
    logOut() {
      this.$store.commit("logout");
      this.$router.replace({ name: "login" });
    },
    goToBackToDash() {
      this.$router.replace({ name: "requests" });
    },
    async changePassword() {
      this.loading = true;
      this.success = false;
      this.error = null;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      try {
        const response = await axios.post(
          `account/password/${this.$ApiVersion}/change`,
          JSON.stringify(this.data),
          options
        );

        this.loading = false;
        if (response.data.StatusCode === 200) {
          this.success = true;
        } else {
          this.error = response.data.StatusMessage;
        }
      } catch (error) {
        this.loading = false;
        this.error = error.message;
      }
    },
  },
};
</script>

<style scoped>
/* The rest of the scoped styles remain the same */
</style>
